import Footer from "../shared/Footer";
import React, {Component} from "react";
import '../styles/Rozklad.css'
import {Button, ControlLabel} from "react-bootstrap";
import Select from 'react-select'
import DatePicker from "react-datepicker/es/index";
import moment from "moment";
import RozkladService from "./RozkladService";
import WynikiRozklad from "./WynikiRozklad";
import PokazSzczegolyRozklad from "./PokazSzczegolyRozklad";
import {Link} from "react-router-dom";
import {NotificationManager} from "react-notifications";
import Error from "../home/Error";

export default class Rozklad extends Component {

    constructor(props) {
        super(props);

        let trasa = '';
        let data = moment();
        let wyszukaj = false;

        if (this.props.match.params.data !== undefined && this.props.match.params.id !== undefined) {
            data = moment(this.props.match.params.data);

            if(data.format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')){
                data = moment();
            }

            trasa = {value: this.props.match.params.id, label: this.props.match.params.trasa};
            wyszukaj = true;
            this.searchRozklad(data.format('YYYY-MM-DD'), trasa.value)
        }

        this.state = {
            data: data,
            trasa: trasa,
            trasy: [],
            loading: true,
            wyniki: [],
            wyszukaj: wyszukaj,
            wyswietlSzczegoly: {},
        };

        this.onChangeTrasa = this.onChangeTrasa.bind(this);
        this.onChangeData = this.onChangeData.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        let redirect = true;
        RozkladService.getTrasy()
            .then(function (response) {
                for (let i = 0; i < response.data.length; i++) {

                    if (this.props.match.params.data !== undefined && this.props.match.params.id !== undefined) {
                        if (response.data[i].nazMiOd + ' - ' + response.data[i].nazMiDo === this.props.match.params.trasa && parseInt(response.data[i].idTr) === parseInt(this.props.match.params.id)) {
                            redirect = false
                        }
                    } else {
                        redirect = false
                    }

                    this.setState(prevState => ({
                        trasy: [...prevState.trasy, {
                            value: response.data[i].idTr,
                            label: response.data[i].nazMiOd + ' - ' + response.data[i].nazMiDo
                        }]
                    }))
                }
            }.bind(this)).catch(err => {
        }).then(() => {
            this.setState({redirect: redirect, loading: false})
        });
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChangeData(e) {
        if (e.dayOfYear() < moment().dayOfYear() && e.format('YYYY') <= moment().format('YYYY')) {
            this.setState({data: moment()})
        } else {
            this.setState({data: e})
        }
    }

    pokazSzczegoly(id) {
        this.setState({
            wyswietlSzczegoly: {
                ...this.state.wyswietlSzczegoly,
                [id]: !this.state.wyswietlSzczegoly[id]
            }
        });
    }

    renderujSzczegoly(item) {
        return <PokazSzczegolyRozklad item={item} pokazSzczegoly={(id) => this.pokazSzczegoly(id)}/>
    }

    searchRozklad(data, trasa) {
        let trasyId = []
        RozkladService.getTrasy()
            .then(function (response) {
                for (let i = 0; i < response.data.length; i++) {
                    trasyId.push(response.data[i].idTr)
                }
            }).then(() => {
            if (trasyId.includes(parseInt(trasa))) {
                RozkladService.getKursy(trasa, data)
                    .then(function (response) {
                        this.setState({wyniki: response.data, wyszukaj: true})
                    }.bind(this)).catch(err => {
                    this.setState({redirect: true})
                });
            } else {
                this.setState({redirect: true})
            }
        })
    }

    showNotification() {
        NotificationManager.error("", "Wybierz trasę ", 5000)
    }

    render() {
        return (
            <div>
                <div>
                    {this.state.loading ?
                        <div style={{
                            paddingTop: 200,
                            paddingBottom: 200,
                            textAlign: 'center',
                            color: '#58b13d',
                            background: '#efefef'
                        }}>
                            <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                        </div> :
                        <div>
                            {this.state.redirect ? <Error/> : <div>
                                <div className="rozklad-wyszukiwarka">
                                    <div className="container">

                                        <div className="row">
                                            <div className="col-xl-1">&nbsp;</div>
                                            <div className="col-xl-6">
                                                <ControlLabel>
                                                    <i className={'fa fa-exchange'}> </i> Wybierz trasę
                                                </ControlLabel>
                                                <Select style={{height: 40}} value={this.state.trasa}
                                                        onChange={this.onChangeTrasa}
                                                        options={this.state.trasy}
                                                        placeholder={'Wybierz trasę'}
                                                        matchPos="start"
                                                        clearable={false}/>
                                            </div>
                                            <div className="col-sm-2 rozklad-padding">
                                                <ControlLabel>
                                                    <i className={'fa fa-calendar'}> </i> Wybierz datę
                                                </ControlLabel>
                                                <DatePicker
                                                    dateFormat="YYYY-MM-DD"
                                                    style={{height: 40, paddingLeft: 0}}
                                                    readOnly
                                                    selected={this.state.data}
                                                    onChange={this.onChangeData}
                                                    locale="pl"
                                                />
                                            </div>
                                            <div className="col-sm-2">
                                                {this.state.trasa === '' ?
                                                    <Button bsStyle={'warning'} onClick={() => this.showNotification()}
                                                            style={{marginTop: 30, color: 'white'}}>
                                                        <i className={'fa fa-search'}> </i> Pokaż kursy</Button> :
                                                    <Link
                                                        to={'/rozklad/' + this.state.data.format('YYYY-MM-DD') + '/' + this.state.trasa.value + '/' + this.state.trasa.label}><Button
                                                        bsStyle={'warning'}
                                                        onClick={() => this.searchRozklad(this.state.data.format('YYYY-MM-DD'), this.state.trasa.value)}
                                                        style={{marginTop: 30, color: 'white'}}>
                                                        <i className={'fa fa-search'}> </i> Pokaż kursy</Button></Link>}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="rozklad">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-1">&nbsp;</div>
                                            <div className="col-10">
                                                {!this.state.wyszukaj ?
                                                    <div className="text-center" style={{paddingTop: 120}}><h4
                                                        style={{color: '#858585'}}>Wybierz trasę oraz datę aby
                                                        wyświetlić
                                                        rozkład.</h4></div> : <div>
                                                        {this.state.wyniki.length === 0 ?
                                                            <div className="text-center" style={{paddingTop: 120}}><h3
                                                                style={{color: '#858585'}}>Brak kursów w wybranym
                                                                dniu.</h3>
                                                            </div> :
                                                            <WynikiRozklad wyniki={this.state.wyniki}
                                                                           trasa={this.state.trasa.label}
                                                                           wyswietlSzczegoly={this.state.wyswietlSzczegoly}
                                                                           pokazSzczegoly={(item) => this.pokazSzczegoly(item)}
                                                                           renderujSzczegoly={(item) => this.renderujSzczegoly(item)}/>
                                                        }
                                                    </div>}

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>}</div>}
                    {/*<AplikacjaMobilna/>*/}
                    <Footer/>
                </div>
                }</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/rozklad/Rozklad.js